<template>
    <main class="main-content" id="main-content">
        <div class="container" v-if="loaded">
          <section class="section">
            <page-header>
                <template v-slot:pageTitle>
                  {{$t("profile")}}
                </template>
            </page-header>
            <div class="section__body">
              <div class="profile">
                <div class="row">
                  <div class="col-12 col-sm-6 col-lg-4">
                    <div class="profile-item box bg-white">
                      <div class="profile-item__icon svg-icon color-green" aria-hidden="true">
                        <svg role="img" width="65" height="65" aria-hidden="true">
                          <use xlink:href="#svg-icon-form"></use>
                        </svg>
                      </div>
                      <div class="profile-item__title section__title section__title_style3">{{$t("yourName")}}</div>
                      <div class="profile-item__descr section__description color-gray">{{profile.last_name}} {{profile.first_name}} {{profile.patronymic}}</div>
                      <button class="btn btn_small btn_white profile-item__control" v-if="false" type="button" @click.prevent.stop="edit('editName')">{{$t("change")}}</button>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-lg-4">
                    <div class="profile-item box bg-white">
                      <div class="profile-item__icon svg-icon color-green" aria-hidden="true">
                        <svg role="img" width="65" height="65" aria-hidden="true">
                          <use xlink:href="#svg-icon-smartphone"></use>
                        </svg>
                      </div>
                      <div class="profile-item__title section__title section__title_style3">{{$t("phoneNumber")}}</div>
                      <div class="profile-item__descr section__description color-gray">{{(profile.phone && profile.phone.length > 9) ? `+7 ${profile.phone}` : $t("unknown")}}</div>
                      <button class="btn btn_small btn_white profile-item__control" type="button" @click.prevent.stop="edit('editPhone')">{{$t("change")}}</button>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-lg-4">
                    <div class="profile-item box bg-white">
                      <div class="profile-item__icon svg-icon color-green" aria-hidden="true">
                        <svg role="img" width="65" height="65" aria-hidden="true">
                          <use xlink:href="#svg-icon-address"></use>
                        </svg>
                      </div>
                      <div class="profile-item__title section__title section__title_style3">{{$t("address")}}</div>
                      <div class="profile-item__descr section__description color-gray">{{nursultanToAstana(profile?.profile?.city)}} {{profile?.profile?.address}}</div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-lg-4">
                    <div class="profile-item box bg-white">
                      <div class="profile-item__icon svg-icon color-green" aria-hidden="true">
                        <svg role="img" width="65" height="65" aria-hidden="true">
                          <use xlink:href="#svg-icon-shield"></use>
                        </svg>
                      </div>
                      <div class="profile-item__title section__title section__title_style3">{{$t("password")}}</div>
                      <div class="profile-item__descr section__description color-gray">***************</div>
                      <button class="btn btn_small btn_white profile-item__control" type="button" @click.prevent.stop="edit('editPassword')">{{$t("change")}}</button>
                    </div>
                  </div>
                  <!-- <div class="col-12 col-sm-6 col-lg-4">
                    <div class="profile-item box bg-white">
                      <div class="profile-item__icon svg-icon color-green" aria-hidden="true">
                        <svg role="img" width="65" height="65" aria-hidden="true">
                          <use xlink:href="#svg-icon-message"></use>
                        </svg>
                      </div>
                      <div class="profile-item__title section__title section__title_style3">{{$t("messages")}}</div>
                      <div class="profile-item__descr section__description color-gray">{{$t("included")}}</div>
                      <button class="btn btn_small btn_white profile-item__control" type="button" @click.prevent.stop="edit('editMessage')">{{$t("settings")}}</button>
                    </div>
                  </div> -->
                  <div class="col-12 col-sm-6 col-lg-4">
                    <div class="profile-item box bg-white">
                      <div class="profile-item__icon svg-icon color-green" aria-hidden="true">
                        <svg role="img" width="65" height="65" aria-hidden="true">
                          <use xlink:href="#svg-icon-email"></use>
                        </svg>
                      </div>
                      <div class="profile-item__title section__title section__title_style3">{{$t("email")}}</div>
                      <div class="profile-item__descr section__description color-gray">{{(profile.email && profile.email.includes('@')) ? profile.email : $t("unknown")}}</div>
                      <button class="btn btn_small btn_white profile-item__control" type="button" @click.prevent.stop="edit('editEmail')">{{$t("change")}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
    </main>

    <div class="modal fade modal_form modal_show" v-if="showModal === 'editName'" tabindex="-1" role="dialog" aria-hidden="true" id="modal-edit-name" :aria-label='$t("changeData")'>
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title section__title section__title_style3">
              {{$t("changeData")}}
            </div>
            <button class="btn svg-icon modal-close" type="button" data-dismiss="modal" @click="closeModal" :aria-label='$t("close")'>
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <form id="form-edit-name" name="form-edit-name" method="post" @submit.prevent="updateProfileName">
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-surname-new">{{$t("yourName")}}</label>
                <input class="form-control" type="text" v-model.trim="profile.first_name" name="user-surname-new" id="user-surname-new" :placeholder='$t("yourName")'/>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-first-name-new">{{$t("surname")}}</label>
                <input class="form-control" type="text" v-model.trim="profile.last_name" name="user-first-name-new" id="user-first-name-new" :placeholder='$t("surname")'/>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-last-name-new">{{$t("patronymic")}}</label>
                <input class="form-control" type="text" v-model.trim="profile.patronymic" name="user-last-name-new" id="user-last-name-new" :placeholder='$t("patronymic")'/>
              </div>
              <div class="btn-group">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <button class="btn btn_default btn_green" type="submit">{{$t("save")}}</button>
                  </div>
                  <div class="col-12 col-md-6 order-last order-md-first">
                    <button class="btn btn_default btn_white" type="button" data-dismiss="modal" @click="closeModal">{{$t("cancel")}}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>  

    <!-- Смена телефона-->
    <div class="modal fade modal_form modal_show" tabindex="-1" v-if="showModal === 'editPhone'" role="dialog" aria-hidden="true" id="modal-edit-phone"  :aria-label='$t("changePhoneNumber")'>
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title section__title section__title_style3">
              {{$t("changePhoneNumber")}}
            </div>
            <button class="btn svg-icon modal-close" type="button" data-dismiss="modal" @click="closeModal" :aria-label='$t("close")'>
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <form id="form-edit-phone" name="form-edit-phone" method="post" @submit.prevent="updateProfilePhone">
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-phone-new">{{$t("yourPhoneNUmber")}}</label>
                <input class="form-control" type="tel" v-model.trim="profile.phone" name="user-phone-new" id="user-phone-new" v-mask="'+7 (###) ### ## ##'" placeholder="+7 - - - - - - - - - -" required/>
              </div>
              <div class="btn-group">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <button class="btn btn_default btn_green" type="submit">{{$t("save")}}</button>
                  </div>
                  <div class="col-12 col-md-6 order-last order-md-first">
                    <button class="btn btn_default btn_white" type="button" @click="closeModal" data-dismiss="modal">{{$t("cancel")}}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>  
    <!-- Смена email-->
    <div class="modal fade modal_form modal_show" tabindex="-1" v-if="showModal === 'editEmail'" role="dialog" aria-hidden="true" id="modal-edit-email" :aria-label='$t("changeEmail")'>
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title section__title section__title_style3">
              {{$t("changeEmail")}}
            </div>
            <button class="btn svg-icon modal-close" type="button" @click="closeModal" data-dismiss="modal" :aria-label='$t("close")'>
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <form id="form-edit-email" name="form-edit-email" method="post" @submit.prevent="updateProfileEmail">
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-email-new">{{$t("yourEmail")}}</label>
                <input class="form-control" type="email" v-model.trim="profile.email" name="user-email-new" id="user-email-new" placeholder="useremail@gmail.com" required="required"/>
              </div>
              <div class="btn-group">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <button class="btn btn_default btn_green" type="submit">{{$t("save")}}</button>
                  </div>
                  <div class="col-12 col-md-6 order-last order-md-first">
                    <button class="btn btn_default btn_white" type="button" @click="closeModal" data-dismiss="modal">{{$t("cancel")}}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>  
    <!-- Смена пароля-->
    <div class="modal fade modal_form modal_show" tabindex="-1" v-if="showModal === 'editPassword'" id="modal-edit-password" :aria-label='$t("changePassword")' role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title section__title section__title_style3">
              {{$t("changePassword")}}
            </div>
            <button class="btn svg-icon modal-close" type="button" data-dismiss="modal" @click="closeModal" :aria-label='$t("close")'>
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <form id="form-edit-password" name="form-edit-password" method="post" @submit.prevent="updateProfilePassword">
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-password-old">{{$t("oldPassword")}}</label>
                <input class="form-control" type="password" v-model.trim="oldPassword" name="user-password-old" id="user-password-old" :placeholder='$t("oldPassword")'/>
                <div class="form-validator" :class="{confirm__error: v$.oldPassword.$error}">{{$t("requiredInput")}}</div>
                <div class="form-validator" :class="{confirm__error: error_response}">{{$t("incorrectOldPassword")}}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-password-new">{{$t("newPassword")}}</label>
                <input class="form-control" type="password" :class="{confirm__error: v$.newPassword.$error}" v-model.trim="newPassword" name="user-password-new" id="user-password-new" :placeholder='$t("newPassword")'/>
                <div class="form-validator" :class="{confirm__error: v$.newPassword.$error}">{{$t("incorrectPassword")}}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-password-confirm">{{$t("repeatPassword")}}</label>
                <input class="form-control" type="password" :class="{confirm__error: v$.confirmPassword.$error}" v-model.trim="confirmPassword" name="user-password-confirm" id="user-password-confirm" :placeholder='$t("repeatPassword")'/>
                <div class="form-validator" :class="{confirm__error: v$.confirmPassword.$error}">{{$t("incorrectRepeatPass")}}</div>
              </div>
              <div class="btn-group">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <button class="btn btn_default btn_green" type="submit">{{$t("save")}}</button>
                  </div>
                  <div class="col-12 col-md-6 order-last order-md-first">
                    <button class="btn btn_default btn_white" type="button" @click="closeModal" data-dismiss="modal">{{$t("cancel")}}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>  
    <!-- Настройка сообщений-->
    <div class="modal fade modal_form modal_show" v-if="showModal === 'editMessage'" id="modal-edit-messages" :aria-label='$t("messageSettings")' tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title section__title section__title_style3">
              {{$t("messageSettings")}}  
            </div>
            <button class="btn svg-icon modal-close" type="button"  @click="closeModal" data-dismiss="modal" aria-label="Закрыть">
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <form id="form-edit-messages" name="form-edit-messages" method="post" @submit.prevent="updateMessageSetting">
              <ul class="list list_unstyled checkbox-list">
                <li class="list__item checkbox">
                  <label class="checkbox__label" for="messages-of-promotions">
                    <input class="checkbox__hidden" type="checkbox" v-model="profile.profile.is_promo_subs" id="messages-of-promotions" name="messages-of-promotions" :value='$t("getNewPromotions")'/><span class="checkbox__custom svg-icon" aria-hidden="true">
                      <svg role="img" width="10" height="10">
                        <use xlink:href="#svg-icon-check"></use>
                      </svg></span><span class="checkbox__title">{{$t("getNewPromotions")}}</span>
                  </label>
                </li>
                <li class="list__item checkbox">
                  <label class="checkbox__label" for="messages-of-news">
                    <input class="checkbox__hidden" type="checkbox"  v-model="profile.profile.is_news_subs" id="messages-of-news" name="messages-of-news" :value='$t("getNews")'/><span class="checkbox__custom" aria-hidden="true">
                      <svg role="img" width="10" height="10">
                        <use xlink:href="#svg-icon-check"></use>
                      </svg></span><span class="checkbox__title">{{$t("getNews")}}</span>
                  </label>
                </li>
              </ul>
              <div class="btn-group">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <button class="btn btn_default btn_green" type="submit">{{$t("save")}}</button>
                  </div>
                  <div class="col-12 col-md-6 order-last order-md-first">
                    <button class="btn btn_default btn_white" type="button"  @click="closeModal" data-dismiss="modal">{{$t("cancel")}}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>   
    <!-- Информационная модалка -->
    <div class="modal fade modal_form modal_show" tabindex="-1" v-if="showModal === 'infoModal'" role="dialog" aria-hidden="true"  :aria-label='$t("changeEmail")'>
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title section__title section__title_style3">
              {{$t("changeEmail")}}
            </div>
            <button class="btn svg-icon modal-close" type="button" data-dismiss="modal" @click="closeModal" :aria-label='$t("close")'>
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <div class="information__text">
              {{$t("updatedEmail")}}
            </div>
            <button class="btn btn_default btn_white" type="button" @click="closeModal" data-dismiss="modal">{{$t("close")}}</button>
          </div>
        </div>
      </div>
    </div>   
</template>
<script>
import useValidate from "@vuelidate/core";
import { required, sameAs, minLength } from "@vuelidate/validators";
import PageHeader from "@/components/PageHeader";
import ModalWindow from "@/components/UI/ModalWindow";
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  data() {
    return {
      v$: useValidate(),
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      error_response: false,
      preloader: document.querySelector('.preloader'),
      loaded: false,
      showModal: ''
    }
  },
  validations() {
  	return {
      oldPassword: { required },
      newPassword: {
        required,
          minLength: minLength(8),
          containsUppercase: function(value) {
            return /[A-Z]/.test(value)
          },
          containsLowercase: function(value) {
            return /[a-z]/.test(value)
          },
          containsNumber: function(value) {
            return /[0-9]/.test(value)
          },
      },
      confirmPassword: { 
          required, 
          sameAsPassword: sameAs(this.newPassword),
      },
    }
  },
  components: {
    PageHeader,
    ModalWindow
  },
  computed: {
    ...mapGetters({
        profile: 'profile/profileData'
    }),
  },
  methods: {
    ...mapActions({
      getProfile: 'profile/getProfile',
      updateProfile: 'profile/updateProfile',
      settingMessage: 'profile/settingMessage',
      changePassword: 'profile/changePassword',
      emailVerif: 'profile/emailVerification'
    }),
    updateProfileName(event) {      
      const { first_name, last_name, patronymic } = this.profile
  		this.updateProfile({ first_name, last_name, patronymic }).then((resp) => {
        if (resp === 200){
          toastr.success(this.$t("editSuccess"));
          this.closeModalCommand(event.target)
        }else{
          toastr.error(this.$t("isError"));
        }
        this.getProfile();
      })	
    },
    // updateProfilePhone(event) {
    //   const { id_client, email, phone } = this.profile    
  	// 	this.updateProfile({ id_client, email, phone }).then((resp) => {
    //     if (resp === 200){
    //       toastr.success(this.$t("editSuccess"));
    //       this.closeModalCommand(event.target)
    //     }else{
    //       toastr.error(this.$t("isError"));
    //     }
    //     this.getProfile();
    //   })	
    // },
    updateProfilePhone(event) {  
      let { id_client, email, phone } = this.profile

      if (phone.startsWith("+7") && phone.includes("(")){
        phone = phone.replace(/\s+/g, '').replace('(', '').replace(')', '').slice(2);
      }
      
  		this.updateProfile({ id_client, email, phone }).then((resp) => {
        if (resp === 'Phone updated'){
          toastr.success(this.$t("updatedPhoneNumber"));
          this.closeModalCommand(event.target)
        }else if(resp === 'Not updated'){
          toastr.warning(this.$t("notUpdated"));
          this.closeModalCommand(event.target)
        }else if(resp === 'phone Exist'){
          toastr.warning(this.$t("existPhone"));
        }else if(resp === 'phone incorrect'){
          toastr.warning(this.$t("incorrectNumber"));
        }else if(resp === 'updated error'){
          toastr.warning(this.$t("updatedError"));
        }else{
          toastr.error(this.$t("isError"));
          this.closeModalCommand(event.target)
        }
      })	
      .finally(() => {
        this.getProfile();
      })
    },
    updateProfileEmail(event) {      
      const { id_client, email, phone } = this.profile
  		this.updateProfile({ id_client, email, phone }).then((resp) => {
        if(resp === 'Message email update'){
          this.closeModalCommand(event.target)
          this.edit('infoModal');
        }else if(resp === 'Not updated'){
          toastr.warning(this.$t("notUpdated"));
          this.closeModalCommand(event.target)
        }else if(resp === 'email Exist'){
          toastr.warning(this.$t("existEmail"));
        }else if(resp === 'email incorrect'){
          toastr.warning(this.$t("incorrectEmail"));
        }else if(resp === 'updated error'){
          toastr.warning(this.$t("updatedError"));
        }else{
          toastr.error(this.$t("isError"));
          this.closeModalCommand(event.target)
        }
      })	
      .finally(() => {
        this.getProfile();
      })
    },
    updateProfilePassword(event) {  
      this.error_response = false
      this.v$.$validate() 
  		if (!this.v$.$error) {
        let password = {old_password: this.oldPassword, password: this.newPassword, password_confirm: this.confirmPassword}    
        this.changePassword(password).then((resp) => {
          if (resp === 200){
            toastr.success(this.$t("editSuccess"));
            this.closeModalCommand(event.target)
          }else{
            toastr.error(this.$t("isError"));
            this.error_response = true
          }
          this.getProfile();
        })
      }	
    },
    updateMessageSetting(event) {    
      let newMessSetting = {
        profile: {}
      }  
      newMessSetting.profile.is_promo_subs = this.profile.profile.is_promo_subs
      newMessSetting.profile.is_news_subs = this.profile.profile.is_news_subs
  		this.settingMessage(newMessSetting).then((resp) => {
        if (resp === 200){
          toastr.success(this.$t("editSuccess"));
          this.closeModalCommand(event.target)
        }else{
          toastr.error(this.$t("isError"));
        }
        this.getProfile();
      })	
    },
    verification(token){
      if(token){
        this.emailVerif(token).then((resp) => {
          if(resp === 200){
            toastr.success(this.$t("changedEmail"));
            this.getProfile();
          }else{
            toastr.error(this.$t("isError"));
          }
        })
      }
    },
    nursultanToAstana(cityName = ''){
      return cityName.toLowerCase().includes('нур-султан') ? 'Астана' : cityName;
    },
    closeModalCommand(elem) {
      elem.parentElement.previousElementSibling.lastChild.click()
    },
    showPreloader() {
      this.preloader.classList.remove('d-none')
    },
    hidePreloader() {
      this.preloader.classList.add('d-none');
    },
    edit(modalName) {
      this.showModal = modalName;
    },
    closeModal() {
      this.showModal = ''
    },
    isEmpty(obj) {
      for (let key in obj) {
        return false;
      }
      return true;
    }
  },
  created() {
    if(this.isEmpty(this.profile)){
      this.showPreloader()
      this.getProfile().then(res => {
        if(res === 200){
          this.hidePreloader()
          this.loaded = true
        }else if(res === 404){
          this.$router.push({ name: '404' })
          this.hidePreloader()
        }
      });
    }else{
      this.loaded = true
    }
    if(location.search){
      this.verification(location.search.substr(7))
    }
  }
}
</script>
<style scoped>
.confirm__error{
  opacity: 1;
  visibility: inherit;
}
.modal_show{
  display: block;
  opacity: 1;
  background: rgba(255,255,255,.5);
}
.information__text{
  color: #329e60;
  margin: 10px 0 20px 0;
}
</style>